module.exports = __webpack_public_path__ + "static/media/36import-70.68f426bf.xlsx";